export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";